module.exports = __webpack_public_path__ + "img/profile_teo_wk.2d44028f.jpg";